// 🚨 Auto-generated file. Do not edit manually.

export const fotoImages = {
  customerSatisfaction: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1742386332/mad-web-app/foto-images/customer-satisfaction.png',
    publicId: 'mad-web-app/foto-images/customer-satisfaction',
    alt: 'Customer Satisfaction Foto Image',
  },
  fotoImage12: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1742018126/mad-web-app/foto-images/foto-image-12.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-12',
    alt: 'Foto Image 12 Foto Image',
  },
  fotoImage11: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741892429/mad-web-app/foto-images/foto-image-11.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-11',
    alt: 'Foto Image 11 Foto Image',
  },
  fotoImage10: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741892234/mad-web-app/foto-images/foto-image-10.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-10',
    alt: 'Foto Image 10 Foto Image',
  },
  fotoImage09: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741882721/mad-web-app/foto-images/foto-image-09.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-09',
    alt: 'Foto Image 09 Foto Image',
  },
  fotoImage08: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741882515/mad-web-app/foto-images/foto-image-08.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-08',
    alt: 'Foto Image 08 Foto Image',
  },
  fotoImage07: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741881449/mad-web-app/foto-images/foto-image-07.heic',
    publicId: 'mad-web-app/foto-images/foto-image-07',
    alt: 'Foto Image 07 Foto Image',
  },
  fotoImage06: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741881272/mad-web-app/foto-images/foto-image-06.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-06',
    alt: 'Foto Image 06 Foto Image',
  },
  fotoImage13: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741880639/mad-web-app/foto-images/foto-image-13.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-13',
    alt: 'Foto Image 13 Foto Image',
  },
  fotoImage05: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741880520/mad-web-app/foto-images/foto-image-05.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-05',
    alt: 'Foto Image 05 Foto Image',
  },
  fotoImage04: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740961731/mad-web-app/foto-images/foto-image-04.webp',
    publicId: 'mad-web-app/foto-images/foto-image-04',
    alt: 'Foto Image 04 Foto Image',
  },
  after: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740576226/mad-web-app/foto-images/after.jpg',
    publicId: 'mad-web-app/foto-images/after',
    alt: 'After Foto Image',
  },
  before: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740576207/mad-web-app/foto-images/before.jpg',
    publicId: 'mad-web-app/foto-images/before',
    alt: 'Before Foto Image',
  },
  fotoImage03: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740574552/mad-web-app/foto-images/foto-image-03.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-03',
    alt: 'Foto Image 03 Foto Image',
  },
  fotoImage02: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740531440/mad-web-app/foto-images/foto-image-02.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-02',
    alt: 'Foto Image 02 Foto Image',
  },
  fotoImage01: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739412349/mad-web-app/foto-images/foto-image-01.jpg',
    publicId: 'mad-web-app/foto-images/foto-image-01',
    alt: 'Foto Image 01 Foto Image',
  },
  fotoImage14: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739367271/mad-web-app/foto-images/foto-image-14.webp',
    publicId: 'mad-web-app/foto-images/foto-image-14',
    alt: 'Foto Image 14 Foto Image',
  },
  davidMayes: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739301587/mad-web-app/foto-images/david-mayes.jpg',
    publicId: 'mad-web-app/foto-images/david-mayes',
    alt: 'David Mayes Foto Image',
  },
};
